import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../../../store/authStore'
import { useSceneStore } from '../sceneStore'
import { CrtButton } from '../../../components/crt'

const TPG_LOGO_URL = 'https://the-platform-group.com/wp-content/uploads/2021/09/TPG_EPS_white_png-1-2.png'

export function LandingOverlay({ sessionRouteId, onEnterWithoutSession }) {
  const { isAuthenticated } = useAuthStore()
  const dismissLanding = useSceneStore((s) => s.dismissLanding)
  const navigate = useNavigate()

  const handleEnter = async () => {
    dismissLanding()
    if (sessionRouteId) {
      navigate(`/app/s/${sessionRouteId}`, { replace: true })
      return
    }
    if (onEnterWithoutSession) {
      const created = await onEnterWithoutSession()
      const routeId = created?.public_id || created?.id
      if (routeId) navigate(`/app/s/${routeId}`, { replace: true })
      else navigate('/app', { replace: true })
      return
    }
    navigate('/app', { replace: true })
  }

  return (
    <div className="landing-overlay" role="dialog" aria-label="Welcome to ARIA">
      <div className="landing-overlay-inner">
        <img src={TPG_LOGO_URL} alt="TPG" className="landing-logo" />
        <h1 className="landing-title">ARIA</h1>
        <p className="landing-sub">Ticket intelligence for operators</p>
        <p className="landing-copy">
          Describe what to ship. ARIA listens, reads your repo, and drafts tickets for Jira or Asana — all in one neural console.
        </p>
        <CrtButton fullWidth onClick={handleEnter}>
          {isAuthenticated ? 'Resume console' : 'Enter console'}
        </CrtButton>
      </div>
    </div>
  )
}
